<template>
    <div class="day-column">
        <div
            class="day-date"
            :class="{'day-date-current': showCurrentDay}"
        >
            <span class="day-name">{{ dayInfo.weekday }}</span>
            <span>{{ dayInfo.day }}</span>
        </div>
        <div v-if="daySettings.isUnavailable "
        >
            <div class="time-slot time-slot-taken"
                 v-for="n in 5"
                 :key="n"></div>
        </div>
        <div
            v-else
            class="time-slot"
            v-for="(timeSlot, index) in calculatedSlots"
            :key="index"
        >
            <input
                type="radio"
                class="rad"
                :id="`id-${timeSlot}-${index}`"
                :value="`${timeSlot}`"
                v-model="slot"
                :name="`${timeSlot}`"
                @input="updateSelectedSlot(timeSlot)"
            >
            <label :for="`id-${timeSlot}-${index}`">
                {{ getTimeForTimeSlots(timeSlot) }}
            </label>
        </div>
    </div>
</template>

<script>
import DateConverter from "../../../../../../../resources/js/mixins/DateConverter";
import moment from "moment";

export default {
    name: 'DaySlots',
    props: {
        selectedDay: {
            type: Date
        },
        events: {
            type: Array
        },
        workdaySettings: {
            type: Object,
            required: true,
        },
        dayInfo: {
            type: Object
        },
        selectedSlot: {
            type: String
        },
        maxDate: String,
    },
    mixins: [DateConverter],
    data() {
        return {
            bufferTime: null,
            calculatedSlots: [],
            daySettings: {},
            finalQuantityOfSlots: null,
            startTime: null,
            showCurrentDay: false,
            slot: null,
        }
    },
    methods: {
        setUnavailableDays() {
            if (this.daySettings.start) {
                let startWorkingDay = this.formatTimeStamp(this.dayInfo.date, this.daySettings.start)

                const minAllowedDate = moment().add(-1, 'days').toDate();
                const isBeforeMinAllowedDate = moment(startWorkingDay).isBefore(moment(minAllowedDate));
                const isAfterMaxAllowedDate = moment(startWorkingDay).isAfter(moment(this.maxDate));

                this.daySettings.isUnavailable = isBeforeMinAllowedDate || isAfterMaxAllowedDate;
            }
        },
        calculationOfTheNumberOfSlots(totalWorkingTime, oneSlotDurationWithBreak) {
            const slots = Math.floor(totalWorkingTime / oneSlotDurationWithBreak);
            if (this.workdaySettings.maximum_bookings > slots) {
                this.finalQuantityOfSlots = slots
            } else {
                this.finalQuantityOfSlots = this.workdaySettings.maximum_bookings
            }
        },
        calculateTimeSlots(start, duration, breakTime) {
            const timeSlots = [];
            let slotStartTime = new Date(start).getTime();
            let slotEndTime = slotStartTime + duration + breakTime;

            for (let i = 0; i < this.finalQuantityOfSlots; i++) {
                if (this.slotIsAvailable(slotStartTime, slotEndTime) && this.timeIsAvailable(slotStartTime)) {
                    timeSlots.push(new Date(slotStartTime).toISOString());
                }

                slotStartTime += duration + breakTime;
                slotEndTime += duration + breakTime;
            }
            this.calculatedSlots = timeSlots
        },
        checkCurrentDay() {
            const currentDay = this.calculateDate(this.selectedDay);
            if (currentDay === this.dayInfo.date) {
                this.showCurrentDay = true;
            }
        },
        findScheduleForDay() {
            this.daySettings = this.workdaySettings.schedule.find(el => el.day === this.dayInfo.weekday)
            this.prepareInformationForCalc()
            this.setUnavailableDays()
        },
        prepareInformationForCalc() {
            if (this.daySettings.start && this.daySettings.end) {

                let startWorkingDay = this.formatTimeStamp(this.dayInfo.date, this.daySettings.start)
                let endWorkingDay = this.formatTimeStamp(this.dayInfo.date, this.daySettings.end)

                const totalWorkingTime = new Date(endWorkingDay).getTime() - new Date(startWorkingDay).getTime()
                const durationInMilliseconds = this.workdaySettings.duration * 60 * 1000

                if (this.workdaySettings.buffer_time_units === 'minutes') {
                    this.bufferTime = this.workdaySettings.buffer_time * 60 * 1000
                } else {
                    this.bufferTime = this.workdaySettings.buffer_time * 60 * 1000 * 60
                }
                const oneSlotDurationWithBreak = durationInMilliseconds + this.bufferTime

                this.calculationOfTheNumberOfSlots(totalWorkingTime, oneSlotDurationWithBreak)
                this.calculateTimeSlots(startWorkingDay, durationInMilliseconds, this.bufferTime,)
            }
        },
        timeIsAvailable(slotStartTime) {
            const startTimeForToday = this.getSlotTimeLimit(this.workdaySettings.minimum_time);
            const timePassed = this.getDayForTimeSlot() === this.dayInfo.date && slotStartTime < startTimeForToday
            return !timePassed
        },
        slotIsAvailable(slotStartTime, slotEndTime,) {
            return !this.events.some(event => {
                const eventStartTime = new Date(event.start_date).getTime();
                const eventEndTime = new Date(event.end_date).getTime();

                const slotFullyBusy = slotStartTime < eventStartTime && slotEndTime > eventEndTime;
                const startOfSlotBusy = eventStartTime <= slotStartTime && slotStartTime <= eventEndTime;
                const endOfSlotBusy = eventStartTime < slotEndTime && slotEndTime < eventEndTime;
                return slotFullyBusy || startOfSlotBusy || endOfSlotBusy ;

            });
        },
        updateSelectedSlot(slot) {
            this.$emit('update-slot', slot)

        }
    },
     mounted() {
        this.findScheduleForDay();
        this.checkCurrentDay();
         if (this.calculatedSlots.length <= 0) {
             this.daySettings.isUnavailable = true
         }
    },
    watch: {
        selectedSlot(newVal, oldVal) {
            if (newVal !== this.slot) {
                this.slot = null;
            }
        }
    }

}

</script>


<style scoped>

</style>
